// src/components/today/AllDayEventsBar.tsx
import React from 'react';
import { Event } from '../../types/calendar-event';
import { Sun } from '../common/icons';

interface AllDayEventsBarProps {
  allDayEvents: Event[];
  maxVisibleEvents?: number;
}

const AllDayEventsBar: React.FC<AllDayEventsBarProps> = React.memo(({ 
  allDayEvents, 
  maxVisibleEvents = 3 
}) => {
  // 如果沒有全天事件，則不渲染
  if (!allDayEvents || allDayEvents.length === 0) {
    return null;
  }

  const visibleEvents = allDayEvents.slice(0, maxVisibleEvents);
  const hiddenCount = allDayEvents.length - maxVisibleEvents;

  return (
    <div 
      className="subheader-wrapper" 
      role="banner" 
      aria-label="Today's all-day events"
    >
      <div className="subheader-container">
        <div className="flex items-center gap-3 w-full">
          {/* 左側圖標 */}
          <div 
            className="flex items-center text-neutral-500 flex-shrink-0"
            title="All-day events"
          >
            <Sun size={14} />
          </div>
          
          {/* 全天事件列表 */}
          <div className="flex items-center gap-2 flex-1 overflow-hidden">
            {visibleEvents.map((event, index) => (
              <div key={event.id} className="flex items-center gap-2 min-w-0">
                {index > 0 && (
                  <span className="text-neutral-300 text-sm flex-shrink-0">•</span>
                )}
                <span 
                  className="text-sm text-neutral-700 truncate min-w-0"
                  title={event.title}
                >
                  {event.title || 'Untitled event'}
                </span>
              </div>
            ))}
            {hiddenCount > 0 && (
              <span className="text-sm text-neutral-500 flex-shrink-0 ml-1">
                +{hiddenCount} more
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

AllDayEventsBar.displayName = 'AllDayEventsBar';

export default AllDayEventsBar;